angular
    .module('tradersyard')
    .controller('graph-modal-ctrl', [
        '$scope',
        '$rootScope',
        function ($scope, $root) {
            $scope.showModal = false;
            $scope.data = {
                title: undefined,
                content: undefined,
                type: 'default',
                scope: 'default',
                buttons: [],
            };

            $scope.close = function () {
                document.documentElement.style.overflowY = 'scroll';
                $scope.showModal = false;
                $root.$broadcast('modal:event:close');
            };

            $scope.open = function () {
                $scope.showModal = true;
                $root.$broadcast('modal:event:open');
            };

            $scope.event = function (button) {
                $scope.showModal = false;
                $root.$broadcast('modal:' + $scope.data.scope + ':button', button);
            };

            $scope.$on('graph-modal-hide', function () {
                $scope.close();
            });

            $scope.$on('graph-modal-show', function (e, data) {
                document.documentElement.style.overflowY = 'hidden';
                $scope.data = data;
                // setTimeout(function() {})
                $scope.open();
            });
        },
    ])
    .controller('preview-ctrl', [
        '$scope',
        '$rootScope',
        '$parse',
        '$flex.array',
        function ($scope, $root, $parse, $array) {
            $scope.buffer = {};
            $scope.show = false;
            $scope.nodes = [];
            $scope.node = {};
            $scope.type = undefined;
            $scope.current = null;
            $scope.access = false;
            $scope.entry = undefined;
            $scope.entryId = undefined;
            $scope.process = false;
            $scope.pool = [];
            $scope.source = '';
            $scope.maxHeight = 600;
            $scope.maxWidth = 900;
            $scope.style = {
                'max-width': $scope.maxWidth + 'px',
                'max-height': $scope.maxHeight + 'px',
            };

            $scope.handler = {
                update: function () {},
                delete: function () {
                    $array.$splice($scope.pool, $scope.node, 'id');

                    $array.$splice($scope.nodes, $scope.node, 'id');

                    $scope.node = undefined;

                    $scope.close();
                    digest();
                },
            };

            $scope.$on('preview-touch', function ($event, $data) {
                if ($data.nodes.length > 0) {
                    $scope.type = $data.type;
                    $scope.nodes = $data.nodes;
                    $scope.current = $data.current;
                    $scope.pool = $data.pool;
                    $scope.access = $data.access || false;
                    $scope.entry = $data.entry || undefined;
                    $scope.entryId = $data.entryId || undefined;

                    $scope.render($data.current);

                    $scope.open();
                }
            });

            $scope.open = function () {
                $scope.show = true;

                var w1 = document.body.offsetWidth,
                    w2;

                angular.element(document.querySelector('body')).addClass('lock');

                w2 = document.body.offsetWidth;

                document.body.style.paddingRight = w2 - w1 + 'px';

                digest();
            };

            $scope.close = function () {
                $scope.show = false;
                $scope.source = undefined;

                document.body.style.paddingRight = '';

                angular.element(document.querySelector('body')).removeClass('lock');
            };

            $scope.render = function (current) {
                $scope.process = true;
                $scope.node = $scope.nodes[current ? current : $scope.current];

                if ($scope.type === 'image') {
                    $scope.source = $scope.node.source;

                    $scope.process = false;

                    digest();

                    return false;

                    // var $api = new Image();
                    //
                    // $api.onload = function() {
                    //     var w = window,
                    //         d = document,
                    //         e = d.documentElement,
                    //         g = d.getElementsByTagName('body')[0],
                    //         x = w.innerWidth || e.clientWidth || g.clientWidth,
                    //         y = w.innerHeight|| e.clientHeight|| g.clientHeight;
                    //
                    //     $scope.maxHeight    = y - 40;
                    //     $scope.maxWidth     = x - 40;
                    //
                    //     var resolution = {
                    //         width   : $scope.maxWidth,
                    //         height  : $scope.maxHeight
                    //     };
                    //
                    //     $scope.source = $scope.node.source;
                    //
                    //     $scope.buffer[$scope.node.id] = resolution;
                    //
                    //     $scope.style        = {
                    //         'max-width' : resolution.width  + 'px',
                    //         'max-height': resolution.height + 'px'
                    //     };
                    //
                    //     $scope.process = false;
                    //
                    //     digest();
                    // };
                    //
                    // $api.src = $scope.node.source;
                    //
                    // if ($scope.buffer[$scope.node.id] !== undefined)
                    //     $scope.style        = {
                    //         'max-width' : $scope.buffer[$scope.node.id].width  + 'px',
                    //         'max-height': $scope.buffer[$scope.node.id].height + 'px'
                    //     };
                } else if ($scope.type === 'video') {
                    $scope.source = $scope.node.source;

                    $scope.process = false;

                    digest();
                }
            };

            var digest = function () {
                if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                    $scope.$apply();
                }
            };

            $scope.next = function () {
                var current = $scope.current + 1;

                if (current > $scope.nodes.length - 1) current = 0;

                $scope.current = current;

                $scope.render(current, true);
            };

            $scope.prev = function () {
                var current = $scope.current - 1;

                if (current < 0) current = $scope.nodes.length - 1;

                $scope.current = current;

                $scope.render(current, true);
            };

            $scope.filtrate = function (value) {
                return value && value.length > 0 && value.length <= 255;
            };

            angular.element(document.querySelector('body')).bind('keydown keypress', function (e) {
                if (e.which === 27) {
                    if ($scope.show === true) {
                        angular.element(document.querySelector('#preview-close')).triggerHandler('click');

                        e.preventDefault();
                    }
                }

                if (e.which === 37) {
                    if ($scope.show === true) {
                        $scope.prev();

                        e.preventDefault();
                    }
                }

                if (e.which === 39) {
                    if ($scope.show === true) {
                        $scope.next();

                        e.preventDefault();
                    }
                }
            });

            angular.element(document.querySelector('body')).bind('click', function (e) {
                if (angular.element(e.target).hasClass('photo-preview-main') && $scope.show === true) {
                    angular.element(document.querySelector('#preview-close')).triggerHandler('click');

                    e.stopPropagation();
                }
            });
        },
    ])
    .controller('home-ctrl', [
        '$rootScope',
        '$scope',
        '$flex',
        'GraphParticipantService',
        'graph-post-factory',
        '$socket',
        '$filter',
        'AdsService',
        '$window',
        function ($rootScope, $scope, $flex, ParticipantService, postFactory, $socket, $filter, AdsService, $window) {
            // region: Boosted Posts

            /**
             * REFACTOR: we need to duplicate a lot of glue code between Private and Public wall feed
             */
            const LOADED_POSTS = [];

            function getRankForRange(range) {
                const rangeRank = {
                    1: AdsService.uniqueRandomGenerator(1, 10),
                    2: AdsService.uniqueRandomGenerator(11, 25),
                    3: AdsService.uniqueRandomGenerator(26, 40),
                };

                const rank = rangeRank[range]();
                console.log('[BOOSTED POSTS] Assigned rank %d', rank);
                return rank;
            }

            const boostedPostsPromise = AdsService.getBoostedPostsWithAssignedRank(getRankForRange).catch((err) => {
                console.warn('No boosted post fetched');
                return []; // return empty array in case of error, so further processing will work fine
            });

            /**
             * You should call this every time a new list of posts is loaded.
             *
             * @param newPosts
             * @return {angular.IPromise<Object[]>}
             */
            function concatPostsWithBoosted(newPosts) {
                // this appends the new items in place
                LOADED_POSTS.push(...newPosts);

                return boostedPostsPromise.then((boostedPosts) => {
                    return AdsService.combineBoostedPostsInto(boostedPosts, LOADED_POSTS);
                });
            }

            // endregion: Boosted Posts

            $scope.posts = [];
            $scope.design = {};
            $scope.data = {};
            $scope.calendarTab = 'latestSignals'; // enum ('latestSignals', 'quotes', 'economic')
            $scope.currentDate = moment().unix();
            $scope.adminRoles = ['owner', 'executive', 'presenter'];
            $scope.showTopEvents = true;
            $scope.showTopTraders = true;

            function move(key, length) {
                $scope.design[key] = angular.copy($scope.data[key]).slice(0, length);
            }

            $rootScope.$on('onClickOpenEventsFilter', function (e, show) {
                $scope.showTopEvents = show;
            });

            $scope.openRecurringDates = function (node) {
                $rootScope.$broadcast('open:reccuring-dates:modal', node);
            };

            $rootScope.$on('onClickOpenTopTradersFilter', function (e, show) {
                $scope.showTopTraders = show;
            });

            $scope.openUserEvents = function (node) {
                event.stopPropagation();

                return $window.open(`/${node.owner.id}#webinar.own-upcoming`, '_self');
            };

            function moveContestCollection(key, length) {
                $scope.design[key] = $scope.data[key].map(function (item, key) {
                    var copied = angular.copy(item);
                    copied.participants = angular.copy(copied.participants).slice(0, length);
                    return copied;
                });
            }

            $scope.userCanEditComment = function (postNode) {
                if (typeof $rootScope.me === 'undefined') {
                    return false;
                }

                if (
                    postNode.photos.length <= 0 &&
                    postNode.videos.length <= 0 &&
                    postNode.documents.length <= 0 &&
                    postNode.owner.id === $rootScope.me.id
                ) {
                    return true;
                }

                return false;
            };

            $scope.userCanDeleteMessage = function (node) {
                var imParticipant = false;

                if (typeof $rootScope.me === 'undefined') {
                    return false;
                }

                var post = $scope.posts.find(function (item) {
                    return item.id === node.place.id;
                });

                if (typeof post !== 'undefined') {
                    imParticipant = post.im_participant && $scope.adminRoles.includes(post.participant_role);
                }

                if (node.owner.id === $rootScope.me.id || imParticipant) {
                    return true;
                }

                return false;
            };

            $scope.limitByScreen = 4;

            $scope.needAuthentication = function ($event) {
                $event.preventDefault();
                $rootScope.$broadcast('open:authentication:dialog', 'signIn');
            };

            $scope.eventsTab = 'upcoming';

            $scope.upevpg = 1;

            function updateEventsPagingUsingCollection(data) {
                $scope.upevpc = data.length - ($scope.limitByScreen - 1);
                $scope.upevpg = 1;
            }

            /**
             * @param tabName enum('upcoming', 'running)
             */
            $scope.onClickChangeEventsTab = function (tabName) {
                $scope.eventsTab = tabName;

                if (tabName === 'upcoming') {
                    updateEventsPagingUsingCollection($scope.design.events);
                } else {
                    updateEventsPagingUsingCollection($scope.design.runningEvents);
                }
            };

            $scope.Join = function (node, entry) {
                ParticipantService.Get(node.id, entry).Join(node.id, 42, function () {
                    node.im_participant = true;
                });
            };

            $scope.$on('screen:break', function (event, screen) {
                revision(screen);
                if (!$scope.$$phase) $scope.$digest();
            });

            $socket.emit('join:publicChannel');

            var postIdList = [];

            $socket.on('post:create', function (data) {
                if (
                    (data.node.place.name !== 'group' && data.node.privacy === 'public') ||
                    (data.node.place.name === 'group' && data.node.place.location.privacy === 'public')
                ) {
                    if (postIdList.indexOf(data.node.id) === -1) {
                        postIdList.push(data.node.id);

                        if (
                            $scope.posts
                                .map(function (item) {
                                    return Number(item.id);
                                })
                                .indexOf(Number(data.node.id)) === -1
                        ) {
                            $scope.posts.unshift(data.node);
                            $socket.emit('join:post', [data.node.id]);
                            if (!$scope.$$phase) $scope.$digest();
                        }
                    }
                }
            });

            $scope.params = {
                timeline: {
                    page: 0,
                },
            };

            $scope.queryTimeLine = function (next) {
                ++$scope.params.timeline.page;

                let currentPage = $scope.params.timeline.page;

                postFactory
                    .entry('public')
                    .query({ params: $scope.params.timeline })
                    .then(function (response) {
                        if (response.data.state !== 0 || response.data.data.length < 1) {
                            return; // early return on error or empty result
                        }

                        let postNodes = response.data.data;

                        concatPostsWithBoosted(postNodes).then((withBoosted) => ($scope.posts = withBoosted));

                        // Start listening for events on those new posts
                        const postIds = postNodes.map((post) => post.id);
                        $socket.emit('join:post', postIds);

                        if (next) next();
                    });
            };

            $scope.tradersyardNews = [];

            postFactory.queryRecommended().then(function (response) {
                $scope.tradersyardNews = response.data.data;
            });

            $socket.on('comment:create', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            ++node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $socket.on('comment:delete', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            --node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            angular.extend($scope, $flex.data);

            $scope.expg = 1;
            $scope.limitExhibitionByScreen = 2;

            setTimeout(function () {
                $scope.upevpc = $scope.design.events.length - 3;
                $scope.upevpg = 1;
                $scope.totrpc = $scope.design.topTraders.length - 3;
                $scope.totrpg = 1;
                $scope.expc = $scope.design.upcomingExhibitions.length - 1;
                $scope.expg = 1;
            });

            $scope.queryTimeLine();

            angular.element(window).bind('beforeunload', function () {
                window.scrollTop = 0;
                window.scrollTo(0, 0);
                document.querySelector('html').scrollTop = 0;
                document.querySelector('html').scrollTo(0, 0);
            });

            function revision(screen) {
                move('groups', 30);
                move('events', 20);
                move('runningEvents', 50);
                move('topAuthors', 30);
                move('topTraders', 20);
                move('mostlyRecommended', 30);
                move('upcomingExhibitions', 30);

                switch (screen ? screen : $scope.break) {
                    case 'huge':
                        // move('events',   6);
                        // move('topAuthor',    7);

                        moveContestCollection('contests');
                        break;

                    case 'large':
                        // move('events',   4);
                        // move('users',    5);
                        moveContestCollection('contests');
                        break;
                }

                switch (screen ? screen : $scope.break) {
                    case 'huge':
                        $scope.limitByScreen = 4;
                        break;

                    case 'large':
                        $scope.limitByScreen = 4;
                        break;

                    case 'default':
                        $scope.limitByScreen = 3;
                        break;

                    case 'small':
                        $scope.limitByScreen = 3;
                        break;

                    case 'tablet':
                        $scope.limitByScreen = 1;
                        break;

                    case 'phone':
                        $scope.limitByScreen = 1;
                        break;
                }

                setTimeout(function () {
                    $scope.upevpc = $scope.design.events.length - ($scope.limitByScreen - 1);
                    $scope.upevpg = 1;
                    $scope.totrpc = $scope.design.topTraders.length - ($scope.limitByScreen - 1);
                    $scope.totrpg = 1;
                });
            }
        },
    ])
    .controller('onbeforunloadNotifyCtrl', [
        '$scope',
        'NativeNotificationService',
        '$window',
        function ($scope, NativeNotificationService, $window) {
            const webinarIframeUrl = localStorage.getItem('webinarIframeUrl');

            if (webinarIframeUrl) {
                const notificationParams = {
                    title: '',
                    options: {
                        tag: 'meeting',
                        body:
                            'You left a page where an online-meeting was running.\n' +
                            'If you want to go back to this meeting, just click this notification.',
                        renotify: true,
                    },
                    events: {
                        click: function (e) {
                            $window.open(webinarIframeUrl, '_blank').focus();
                        },
                    },
                };

                NativeNotificationService.showNotification(notificationParams);

                localStorage.removeItem('webinarIframeUrl');
            }
        },
    ]);
